<template>
  <div>
    <!---------- section1  ------------->
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ passed, failed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout mt-25">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                  >
                    <md-field>
                      <p class="validate">*</p>
                      <label>اسم المستخدم</label>
                      <md-input v-model="Name"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                  >
                    <md-field>
                      <p class="validate">*</p>
                      <label>المجموعة</label>
                      <md-select v-model="groupId">
                        <md-option
                          v-for="group in groups"
                          v-bind:key="group.key"
                          :value="group.key"
                          >{{ group.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="employee"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    >
                    </model-list-select>
                  </div>
                </div>

                <div class="md-layout mt-25">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                  >
                    <ValidationProvider
                      ref="nameValidation"
                      name="Name"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <md-field
                        :class="[
                          { 'md-error': errors.length > 0 },
                          { 'md-valid': errors.length === 0 && Name },
                        ]"
                      >
                        <p class="validate">*</p>

                        <label>اسم الدخول</label>
                        <md-input v-model="userName" type="email"></md-input>
                        <span class="md-error" v-if="errors.length > 0">{{
                          errors[0]
                        }}</span>
                      </md-field>
                    </ValidationProvider>
                  </div>

                  <div
                    v-show="UpdateIdentity"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                  >
                    <md-field>
                      <p class="validate">*</p>

                      <label>كلمة المرور</label>
                      <md-input v-model="password" type="email"></md-input>
                    </md-field>
                  </div>

                  <div
                    v-show="UpdateIdentity"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                  >
                    <md-field>
                      <p class="validate">*</p>

                      <label>تأكيد كلمة المرور</label>
                      <md-input v-model="confarmPassword"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                    :class="{ 'mt-25': UpdateIdentity }"
                  >
                    <md-field>
                      <label>معرف الجهاز</label>
                      <md-input v-model="deviceFingerPrint"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15"
                    :class="{ 'mt-25': UpdateIdentity }"
                    style="padding-right: 0"
                  >
                    <md-checkbox v-model="UpdateIdentity"
                      >تغيير كلمة المرور</md-checkbox
                    >
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                    style="padding-right: 0"
                  >
                    <md-checkbox v-model="isActive"> نشط</md-checkbox>
                  </div>
                  <div class="md-layout-item center-content md-size-100 mt-25">
                    <md-button @click="Save" class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >
                    <md-button @click="clear" class="md-info btn_nanosoft"
                      >جديد</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- Statistics Cards -->
    <div class="md-layout">
      <!-- عدد المستخدمين -->
      <div
        class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33"
      >
        <md-card class="stats-card">
          <md-card-content class="stats-card-content">
            <div class="stats-icon">
              <md-icon class="stats-icon-green">person</md-icon>
            </div>
            <div class="stats-info">
              <span class="stats-number">{{ numberUsers }}</span>
              <span class="stats-label">عدد المستخدمين</span>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <!-- عدد المستخدمين النشطين -->
      <div
        class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33"
      >
        <md-card class="stats-card">
          <md-card-content class="stats-card-content">
            <div class="stats-icon">
              <md-icon class="stats-icon-green">person</md-icon>
            </div>
            <div class="stats-info">
              <span class="stats-number">{{ numberForActiveUsers }}</span>
              <span class="stats-label">عدد المستخدمين النشطين</span>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <!-- عدد المجموعات -->
      <div
        class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33"
      >
        <md-card class="stats-card">
          <md-card-content class="stats-card-content">
            <div class="stats-icon">
              <md-icon class="stats-icon-green">person</md-icon>
            </div>
            <div class="stats-info">
              <span class="stats-number">{{ numberGroups }}</span>
              <span class="stats-label">عدد المجموعات</span>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">البحث</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-layout-item md-size-15">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="اسم المستخدم">{{
                item.name
              }}</md-table-cell>

              <md-table-cell md-label="المجموعة">{{
                item.groupName
              }}</md-table-cell>

              <md-table-cell md-label="الموظف">{{
                item.employeeName
              }}</md-table-cell>

              <md-table-cell md-label="حالة المستخدم">{{
                item.isActive === false ? "غير نشط" : "نشط"
              }}</md-table-cell>

              <md-table-cell md-label="رقم الإصدار">{{
                item.appVersion || "-"
              }}</md-table-cell>

              <md-table-cell md-label="نظام التشغيل">{{
                item.appPlatform || "-"
              }}</md-table-cell>
              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import { ModelListSelect } from "vue-search-select";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
// import { SlideYDownTransition } from "vue2-transitions";
import { extend, ValidationProvider } from "vee-validate";
import {
  required,
  numeric,
  regex,
  confirmed,
  email,
} from "vee-validate/dist/rules";
import env from "../../../../../env";
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
extend("email", email);
export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    // SlideYDownTransition,
    ModelListSelect,
    ValidationProvider,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      errorMessage: "",
      UpdateIdentity: true,
      isActive: true,
      employees: [],
      groups: [],
      numberUsers: 0,
      numberForActiveUsers: 0,
      numberGroups: 0,
      employee: "",
      userName: "",
      deviceFingerPrint: null,
      password: "",
      confarmPassword: "",
      Name: "",
      groupId: "",
      id: "",
      ///////
      boolean1: "",
      isUpdate: false,
      IsAdmin: "Support",
      IsAdminSearch: false,
      Title: "",
      Email: "",
      Password: "",
      Phone: "",
      currentSort: "Titel",
      currentSortOrder: "asc",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100, 500],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  methods: {
    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.Name) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم المستخدم"
          );
        }

        if (!this.groupId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال المجموعة"
          );
        }
        // if (!this.employee) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء اختيار الموظف"
        //   );
        // }
        if (!this.userName) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم الدخول"
          );
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.userName)) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً اسم الدخول يجب أن يكون في صيغة بريد إلكتروني."
          );
        }

        if (this.password === "" && this.UpdateIdentity == true) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال كلمة المرور"
          );
        }
        if (
          this.password !== this.confarmPassword &&
          this.UpdateIdentity == true
        ) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، كلمة المرور غير مطابقة"
          );
        }
        let schema = {
          EmployeeId: this.employee ? this.employee : null,
          Name: this.Name,
          Culture: "ar-LY",
          GroupId: this.groupId,
          IsActive: this.isActive,
          DeviceFingerPrint: this.deviceFingerPrint,
          CanDeleteUser: false,
          UpdateIdentity: this.UpdateIdentity,
          Identity: {
            Name: this.userName,
            Password: this.password,
            ConfirmPassword: this.confarmPassword,
          },
        };

        if (!this.UpdateIdentity) {
          delete schema.Identity.Password;
          delete schema.Identity.ConfirmPassword;
        }

        if (this.id === "") {
          let result = await axios.post(`${env.HR()}/api/users`, schema, {
            headers: { Authorization: "Bearer " + token },
          });
        } else {
          let result = await axios.put(
            `${env.HR()}/api/users/${this.id}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.init();
        this.id = "";
        this.clear();
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },
    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/users`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.groups = result.data.data.groups;
        this.employees = result.data.data.employees;
        this.tableData = result.data.data.users;
        this.numberUsers = result.data.data?.numberUsers || 0;
        this.numberForActiveUsers = result.data.data?.numberForActiveUsers || 0;
        this.numberGroups = result.data.data?.numberGroups || 0;
      } catch (error) {
        return this.notifyVue("top", "center", "danger", error);
      }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
      this.employee = item.employeeId;
      this.Name = item.name;
      this.userName = item.loginName;
      this.groupId = item.groupId;
      this.isActive = item.isActive;
      this.deviceFingerPrint = item.deviceFingerPrint;
      this.UpdateIdentity = false;
      this.id = item.id;
    },
    clear() {
      this.employee = "";
      this.groupId = "";
      this.userName = "";
      this.password = "";
      this.Name = "";
      this.confarmPassword = "";
      this.deviceFingerPrint = null;
      this.isActive = true;
      this.UpdateIdentity = true;
      this.id = "";
      // إعادة تهيئة ValidationProvider للحقل المحدد
      this.$nextTick(() => {
        if (this.$refs.nameValidation) {
          this.$refs.nameValidation.reset();
        }
      });
    },
    handleDelete(item) {
      Swal.fire({
        title: "هل انت متأكد؟",
        text: ` سيتم حذف   ${item.name} من النظام هل انت متأكد`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/users/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            this.message(error);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style scoped>
.stats-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 15px;
}

.stats-card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.stats-icon {
  margin-left: 15px;
}

.stats-icon-green {
  color: #4caf50 !important;
  font-size: 32px !important;
}

.stats-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
}

.stats-number {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.stats-label {
  font-size: 14px;
  color: #666;
}
</style>
